import * as actions from './actions'

const AdminStore = {
  namespaced: true,
  state: {},
  mutations: {},
  actions
}

export default AdminStore
